module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.rankings.length > 0 && _vm.ready) ? _c('div', {
    staticClass: "project-statistics--ranking"
  }, _vm._l((_vm.rankings), function(ranking) {
    return _c('div', {
      key: ranking.position,
      staticClass: "ranking",
      class: _vm.computedRankingClass(ranking)
    }, [_c('div', {
      staticClass: "ranking--position"
    }, [_vm._v("\n      " + _vm._s(ranking.position) + "\n    ")]), _vm._v(" "), _c('div', {
      staticClass: "ranking--user"
    }, [_vm._v("\n      " + _vm._s(ranking.user.display_name) + "\n      "), (ranking.position == 1) ? _c('div', {
      staticClass: "ranking--user-count"
    }, [_vm._v("\n        " + _vm._s(ranking.leads_count) + " " + _vm._s(_vm.$t('statistics.leads')) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "ranking--count"
    }, [_vm._v("\n      " + _vm._s(ranking.leads_count) + "\n    ")]), _vm._v(" "), _c('div', {
      staticClass: "ranking--percentage"
    }, [_c('progress-bar', {
      attrs: {
        "percentage": _vm.formatPercentage(ranking.ranking_percentage),
        "title": _vm.formatPercentage(ranking.ranking_percentage) + '%',
        "is-mini": true
      }
    })], 1)])
  }), 0) : _c('div', {
    staticClass: "project-statistics--ranking is-empty"
  }, [_vm._v("\n  " + _vm._s(_vm.$t('statistics.no_data')) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3373a910","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/projects/ProjectStatisticsRanking.vue
// module id = 1861
// module chunks = 0